var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"input-group"},[_c('note-component',{attrs:{"node":_vm.node,"rows":6}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }